// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-form-item.is-error .input-with-append .el-select-link__button{--error-border-color:#f56c6c;border-color:#f56c6c!important}.el-form-item.is-error .input-with-append--no-button .el-select-link .el-input__inner{border-color:#f56c6c!important;border-right:1px solid #f56c6c!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
